import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getReservationDetails } from '../firebase/firebase';
import styles from './reservation-viewer-style.module.css';

function ReservationViewer({setShowNavBar}) {
    const [data, setData] = useState();

    const params = useParams();
    console.log("Reservation: ", data);

    useEffect(() => {getReservationDetails(params.id).then((data) => {setData(data)})}, [setData, params.id]);
    useEffect(() => setShowNavBar(true));

    if(data == null) {
        return (<div className={styles.page}><h1>Loading Data</h1></div>)
    }

    return (
        <div className={styles.page} style={{display: 'flex', flexDirection: 'column'}}>
            <h1>{data.name}</h1>
            <p style={{fontStyle: 'italic'}}>More data will be displayed here for groups</p>
        </div>
    )
}

export default ReservationViewer